import { render } from "./videoShow.vue?vue&type=template&id=5b76fe74&scoped=true"
import script from "./videoShow.vue?vue&type=script&lang=js"
export * from "./videoShow.vue?vue&type=script&lang=js"

import "./videoShow.vue?vue&type=style&index=0&id=5b76fe74&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b76fe74"]])

export default __exports__